export default __webpack_public_path__ + "static/document-e46af74f75485b3f5d7b9dd42dc9b9a6.png";